import { HighlightedPhrase } from '@openx/components-core/lib/HighlightedPhrase/HighlightedPhrase.tsx';
import { StyledTag, StyledTagContainer, StyledTagLabel } from './components/Tags.styled.tsx';

type TagsProps = {
  tags: string[];
  phrase?: string;
  handleTagClick: (filters: { phrase: string }) => void;
  filled?: boolean;
  id?: string;
};

export function Tags({ tags, id = '', handleTagClick, phrase = '', filled = false }: TagsProps) {
  return (
    <StyledTagContainer container>
      <StyledTagLabel data-test="tags-label">{filled ? 'Popular tags:' : 'Tags:'}</StyledTagLabel>
      {tags.map(tag => (
        <StyledTag
          data-test="tag-button"
          key={`${tag + id}`}
          onClick={() => handleTagClick({ phrase: tag })}
          filled={filled}
        >
          {filled ? <span>{tag}</span> : <HighlightedPhrase searchPhrase={phrase}>{tag}</HighlightedPhrase>}
        </StyledTag>
      ))}
    </StyledTagContainer>
  );
}
